const CloverCreditResponseState = Object.freeze({
    CLOSED: 'CLOSED',
    PENDING: 'PENDING',
});

module.exports = CloverCreditResponseState;
